import { subscriptionRepository } from '../repositories/subscription-repository';

async function getSubscriptionStatus(subscriptionId) {
    if (!subscriptionId) {
        throw Error('Cannot get subscription');
    }

    return subscriptionRepository.getStatus(subscriptionId);
}

export {
    getSubscriptionStatus
};
